import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './vendor.css';
import BrowserApp from './BrowserApp';
import environment from './environment';
import {
  generateCookieBasedRandomVariant,
  generateCookieBasedTest,
  getCookieBasedTest,
} from './modules/ab-test/utils';

if (window) {
  // Configure Facebook
  window.fbAsyncInit = () => {
    window.fbInitialized = true;
    FB.init({
      appId: environment.facebook,
      autoLogAppEvents: false,
      xfbml: true,
      version: 'v3.2',
    });
  };
}


// AB Tests
/*
const {test, variant} = getCookieBasedTest();

console.log('abTest', test, variant);

if (!test || !variant) {
  generateCookieBasedTest('best_landing_title');
  generateCookieBasedRandomVariant();
}
*/


// NOTE: __SSR__ is defined in the renderer.jsx as a hardcoded variable that indicates globally SSR
if (window && window.__SSR__) {
  ReactDOM.hydrate(<BrowserApp />, document.getElementById('root'));
  if (environment.env !== 'production') {
    console.log('ReactDOM hydrated');
  }
}else {
  ReactDOM.render(<BrowserApp />, document.getElementById('root'));
  if (environment.env !== 'production') {
    console.log('ReactDOM rendered');
  }
}
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.jsx